import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Header from '../layout/Header';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BillboardBasic extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.onShow = () => {
            this.showCb();
        };
        this.onHide = () => {
            this.hideCb();
        };
        this.onMove = () => { };
    }

    showCb() {
        super.showCb();
        Header.setWhite(true);
    }
    
    hideCb() {
        
        Header.setWhite(false);
    }
}

Scroll._registerClass('BillboardBasic', ScrollItem__BillboardBasic);

export default ScrollItem__BillboardBasic;
